import { render, staticRenderFns } from "./AccountBindPhone.vue?vue&type=template&id=99e10c30&scoped=true&"
import script from "./AccountBindPhone.vue?vue&type=script&lang=js&"
export * from "./AccountBindPhone.vue?vue&type=script&lang=js&"
import style0 from "./AccountBindPhone.vue?vue&type=style&index=0&id=99e10c30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e10c30",
  null
  
)

export default component.exports